import { z } from '@willow/shared-web';

export const PaymentFormShape = z.object({
  otherAmount: z.string().transform(Number).or(z.number()),
  paymentIntention: z.enum(['total', 'totalWithShortage', 'other']),
});
export type TPaymentFormShape = z.infer<typeof PaymentFormShape>;
